// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4w1O7","title":"styles_title__Y09Xw","bonus":"styles_bonus__gJkOY"};